/**
 * Check keine Ernte
 */
window.checkGeschaetzterErtragKeineErnte = function () {
    const editKeineErnte = $('#edit-keine-ernte');
    const editGeschaetzterErtrag = $('#edit-geschaetzter-ertrag');

    editKeineErnte.on('change', function () {
        if ($(this).is(':checked')) {
            editGeschaetzterErtrag.val('').attr('disabled', 'disabled');
        } else {
            editGeschaetzterErtrag.removeAttr('disabled');
        }
    });

    if (editKeineErnte.is(':checked')) {
        editGeschaetzterErtrag.val('').attr('disabled', 'disabled');
    }
};

/**
 * deleteErtrag
 * @param inputDeleteValue
 * @param inputDeleteClass
 * @param inputMultipleDeleteValue
 * @param elementDeleteWarning
 */
window.deleteErtrag = function(inputDeleteValue, inputDeleteClass, inputMultipleDeleteValue, elementDeleteWarning) {
  if (inputDeleteValue !== '') {
    $(inputDeleteValue).val('');
  }
  if (inputDeleteClass !== '') {
    $(inputDeleteClass).removeClass('text-orange');
  }
  if (inputMultipleDeleteValue !== '') {
    $(inputMultipleDeleteValue).val('');
  }
  if (elementDeleteWarning !== '') {
    $(elementDeleteWarning).remove();
  }
};